export default "__VITE_ASSET__BuMeimql__"